import { mapState } from 'vuex'
import throttle from 'lodash/throttle'
import ScrollMagic from 'scrollmagic'

export default {
  data () {
    return {
      params: {
        limit: 10,
        offset: 0
      },
      total: 0,
      loading: false,
      loaded: false,
      loadEnd: false,
      posts: [],
      savedPosition: 0,
      controller: null
    }
  },

  computed: {
    ...mapState(['pageData']),
    seriesId () {
      return this.pageData && this.pageData.series
    },
  },

  methods: {
    async fetchData () {
      this.loading = true;
      try {
        const res = await this.$http({
          url: '/series/article/search/page/get',
          params: {
            series_id: this.seriesId,
            sort: 'desc',
            weight: 0,
            ...this.params
          }
        })
        if (res.error) throw new Error(res.msg)
        this.total = res.total
        this.posts = this.posts.concat(res.data)
        this.loadEnd = this.total <= this.params.limit + this.params.offset
        this.$nextTick(() => {
          this.bindAnimations(res.data)
        })
        this.loaded = true;
      } catch (error) {
        this.$toast(error.message)
        this.loaded = false
      }
      this.loading = false
    },
    listenScroll: throttle(function () {
      this.savedPosition = window.scrollY
    }, 50),
    reachBottom: throttle(function () {
      const el = document.querySelector('html')
      if (Math.abs(el.scrollHeight - el.clientHeight - el.scrollTop) < 350) {
        this.loadMore()
      }
    }, 100),
    loadMore () {
      if (this.loading) return
      if (this.loadEnd) return
      this.params.offset += this.params.limit
      this.fetchData()
    },
    bindAnimations (posts) {
      posts.forEach(p => {
        const el = document.querySelector(`#post-${p.id}`)
        if (!el) return
        new ScrollMagic.Scene({
          triggerElement: el,
          offset: 0,
          triggerHook: 1,
          reverse: false
        })
        .setClassToggle(el, 'slide')
        .addTo(this.controller)
      });
    }
  },

  activated () {
    window.scrollTo({
      top: this.savedPosition
    })
    window.addEventListener('scroll', this.listenScroll)
  },

  deactivated () {
    window.removeEventListener('scroll', this.listenScroll)
  },

  created () {
    this.fetchData()
  },

  mounted () {
    window.addEventListener('scroll', this.reachBottom)
    this.controller = new ScrollMagic.Controller()
  },

  destoryed () {
    window.removeEventListener('scroll', this.reachBottom)
  }
}